import React from "react";
import { Box, Chip, Tooltip, Typography } from "@mui/material";

// The company a bidder participates with in an auction (given when they
// accepted its terms), for the seller's and admin's participant lists.
const BidderCompanyCell = ({ company, duplicateCompany, acceptedTerms }) => {
  if (!company) {
    return (
      <Typography variant="body2" color="text.secondary">
        {acceptedTerms ? "—" : "Not accepted yet"}
      </Typography>
    );
  }

  const contact = [company.contactName, company.designation]
    .filter(Boolean)
    .join(", ");

  return (
    <Tooltip
      title={
        <>
          {contact && <div>{contact}</div>}
          <div>{company.contactPhone}</div>
          <div>{company.contactEmail}</div>
          <div>
            {[company.city, company.state, company.pinCode]
              .filter(Boolean)
              .join(", ")}
          </div>
        </>
      }
    >
      <Box sx={{ py: 0.5 }}>
        <Typography variant="body2" sx={{ fontWeight: 500 }}>
          {company.companyName}
        </Typography>
        <Typography variant="caption" color="text.secondary" component="div">
          {company.gstin ? `GSTIN ${company.gstin}` : `PAN ${company.pan}`}
        </Typography>
        {duplicateCompany && (
          <Chip
            label="Same company as another bidder"
            size="small"
            color="warning"
            variant="outlined"
            sx={{ mt: 0.5, height: 20, fontSize: 11 }}
          />
        )}
      </Box>
    </Tooltip>
  );
};

export default BidderCompanyCell;
